import { redstone } from "@latticexyz/common/chains";
import { createWagmiConfig } from "@latticexyz/entrykit/internal";
import { http, type Chain } from "viem";
import { chainId } from "./common";

export const chains = [redstone] as const satisfies Chain[];

export const transports = {
  [redstone.id]: http(),
} as const;

export const wagmiConfig = createWagmiConfig({
  chainId,
  // TODO: swap this with another default project ID or leave empty
  walletConnectProjectId: "14ce88fdbc0f9c294e26ec9b4d848e44",
  appName: document.title,
  chains,
  transports,
  pollingInterval: {
    [redstone.id]: 2000,
  },
});
